import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditCountryQuotaModalComponent } from './edit-country-quota-modal.component';
import { TableModule } from '@purespectrum1/ui/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from '@purespectrum1/ui/modal';
import { ButtonModule } from '@purespectrum1/ui/button';

@NgModule({
  declarations: [EditCountryQuotaModalComponent],
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    ButtonModule,
  ],
  exports: [EditCountryQuotaModalComponent],
})
export class EditCountryQuotaModalModule {}
